export class CategoriesFunctions {
    public static formatStrToNavigation(el: 'category' | 'section', str: string) {
        str = str.replaceAll(" ", "-").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        return el + '-' + str.toLocaleLowerCase()
    }
}